import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {userSearchResultStateSelector} from './user-search-result-state.slice';

import type {CachedTableCacheSelector, CachedTableDataSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {UserSearchCriteria} from 'src/openapi/admin/models/UserSearchCriteria';
import type {UserSearchFiltering} from 'src/openapi/admin/models/UserSearchFiltering';
import type {UserSearchResult} from 'src/openapi/admin/models/UserSearchResult';
import type {UserSortField} from 'src/openapi/admin/models/UserSortField';
import type {AppState} from 'src/store/typedef';

export const userSearchResultSlice = getCachedTableDataSlice<
    UserSearchResult[],
    UserSearchCriteria,
    UserSortField,
    UserSearchFiltering
>('userSearchResult');

export const userSearchResultActions = userSearchResultSlice.actions;
const userSearchResultCacheSelector: CachedTableCacheSelector<UserSearchResult[]>
    = state => state.userSearchResult.result.cache;
export const userSearchResultDataSelector: CachedTableDataSelector<UserSearchResult[]>
    = state => state.userSearchResult.result;
export const userSearchResultResultSelector = getCachedTableResultSelector(
    userSearchResultCacheSelector,
    userSearchResultStateSelector,
);

export const allSelectedUsersAccountsSelector = (state: AppState, userIds: number[]) => {
    return [
        ...new Set(state.userSearchResult.result.cache.reduce((acc, cacheItem) => {
            const accountIds: number[] = [];

            cacheItem.item.data.forEach(item => {
                if (userIds.includes(item.id)) {
                    accountIds.push(item.accountId);
                }
            });

            return [...acc, ...accountIds];
        }, [] as number[])),
    ];
};
